import { axios } from '@delta/api-client';

interface ApiProblem {
  detail?: unknown;
}

export function apiErrorMessage(error: unknown, fallback = '请求失败，请稍后重试') {
  if (!axios.isAxiosError<ApiProblem>(error)) return fallback;
  const detail = error.response?.data?.detail;
  return typeof detail === 'string' && detail.trim() ? detail : fallback;
}

const reportedDeleteErrors = new WeakSet<object>();

export function wasDeleteErrorReported(error: unknown): boolean {
  return typeof error === 'object' && error !== null && reportedDeleteErrors.has(error);
}

export function reportDeleteError(
  error: unknown,
  show: (message: string) => void,
  ignoredStatuses: readonly number[] = [401],
): boolean {
  if (!axios.isAxiosError(error) || axios.isCancel(error)
    || error.config?.method?.toLowerCase() !== 'delete'
    || ignoredStatuses.includes(error.response?.status ?? 0)
    || wasDeleteErrorReported(error)) return false;

  reportedDeleteErrors.add(error);
  show(apiErrorMessage(error, '删除失败，请稍后重试'));
  return true;
}
